export default "__VITE_ASSET__BdmVl1kA__"